import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/authaxios";

const initialState = {
    data: [],
    loading: false,
};



export const fetchQwickSilverCouponAction = createAsyncThunk("qwick-silver-coupon", async (data = null, { rejectWithValue }) => {
    console.log("data-->",data)
    const response = await axios.get(
        `/admin/dasboard-details/${data.coupon}/${data.platform}/${data.couponType}`
    );
    return response.data;
});

const qwickSilverCouponSlice = createSlice({
    name: "qwick-silver-coupon",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchQwickSilverCouponAction.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchQwickSilverCouponAction.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.status = action.payload.status_code;
            console.log("state.status==>",state.status)
            if(state.status==401||state.status==500){
                localStorage.clear()
              }

        });
        builder.addCase(fetchQwickSilverCouponAction.rejected, (state, action) => {
            state.loading = false;

            state.error = action.error.message;
        });
    },
});




export const qwickSilverCouponReducer = qwickSilverCouponSlice.reducer;

